
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Portfolio from './pages/Portfolio';

import Login from './admin/Login';
import AdminLayout from './admin/AdminLayout';
import AdminDashboard from './admin/AdminDashboard';

import PortfolioList from './admin/products/PortfolioList';
import AddPortfolio from './admin/products/AddPortfolio';
import EditPortfolio from './admin/products/EditPortfolio';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import AddAdmin from './admin/AddAdmin';
import AdminList from './admin/AdminList';

import { useState, useEffect } from 'react';
import Preloader from './components/Preloader';



function App() {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000); // fake loading 1.2 sec
  }, []);
  return (
    <>

     {loading && <Preloader fullscreen />}


    {!loading && ( <>

      <Navbar />
      <ScrollToTop />  {/* 👈 Auto-scroll on route change */}

      <main id="main-content">
      <Routes >
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/services' element={<Services />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/portfolio' element={<Portfolio />} />



        {/* LOGIN PAGE */}
        <Route path="/login" element={<Login />} />
        {/* <Route path="/admin/register" element={<AddAdmin />} /> */}

        {/* ADMIN PROTECTED ROUTES */}
        <Route
          path="/admin"
          element={
            <AdminProtectedRoute>
              <AdminLayout />
            </AdminProtectedRoute>
          }
        >
          {/* DEFAULT ADMIN DASHBOARD */}
          <Route index element={<AdminDashboard />} />

          <Route path="adminlist" element={<AdminList />} />
          <Route path="add-admin" element={<AddAdmin />} />

          {/* PORTFOLIO ROUTES */}
          <Route path="portfoliolist" element={<PortfolioList />} />
          <Route path="add-portfolio" element={<AddPortfolio />} />
          <Route path="edit-portfolio/:id" element={<EditPortfolio />} />
        </Route>

      </Routes >
      </main>
      <Footer />

       </> )}
    </>
  );
}

export default App;
